import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import {
  DateTimePicker as MUIDateTimePicker,
  DateTimePickerProps,
} from '@mui/x-date-pickers/DateTimePicker'
import {
  MobileDateTimePicker as MUIMobileDateTimePicker,
  MobileDateTimePickerProps,
} from '@mui/x-date-pickers/MobileDateTimePicker'
import { DateValidationError, DateTimeValidationError } from '@mui/x-date-pickers/models'
import { ERROR_TEXT } from 'config'
import { useState, useMemo } from 'react'

function MyDatePicker(
  props: { placeholder?: string; error?: boolean; testid?: string } & DatePickerProps<Date>,
) {
  const [pickerError, setPickerError] = useState<DateValidationError | null>(null)

  const errorMsg = useMemo(() => {
    if (props.error) return ERROR_TEXT.dateFormat
    switch (pickerError) {
      case 'invalidDate': {
        return ERROR_TEXT.dateFormat
      }
      default: {
        return ''
      }
    }
  }, [pickerError, props.error])

  return (
    <DatePicker
      format="yyyy-MM-dd"
      onError={(err) => setPickerError(err)}
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          variant: 'outlined',
          helperText: errorMsg,
          onFocus: (props as any).onFocus,
          onBlur: (props as any).onBlur,
          // for string not eligible date type
          error: props.error || !!pickerError,
          placeholder: props.placeholder,
          inputProps: {
            sx: props.placeholder
              ? {
                  '&::placeholder': {
                    color: 'inherit',
                    opacity: 1,
                  },
                }
              : undefined,
            'data-testid': props.testid,
          },
        },
        popper: {
          placement: 'bottom-end',
        },
      }}
      {...props}
    />
  )
}

export function DateTimePicker(
  props: DateTimePickerProps<Date> & { errMsg?: string; testid: string },
) {
  const [error, setError] = useState<DateTimeValidationError | null>(null)

  const errorMsg = useMemo(() => {
    switch (error) {
      case 'invalidDate': {
        return ERROR_TEXT.dateFormat
      }
      default: {
        return ''
      }
    }
  }, [error])

  return (
    <MUIDateTimePicker
      format="yyyy-MM-dd HH:mm"
      onError={(err) => setError(err)}
      slotProps={{
        textField: {
          fullWidth: true,
          variant: 'outlined',
          size: 'small',
          error: !!props.errMsg || !!error,
          helperText: errorMsg || props.errMsg,
          inputProps: {
            'data-testid': props.testid,
          },
        },
      }}
      sx={{ '& .MuiFormHelperText-root': { mx: 0.3 } /* メッセージの幅がぎりぎり*/ }}
      {...props}
    />
  )
}

export function MobileDateTimePicker(props: MobileDateTimePickerProps<Date>) {
  const [error, setError] = useState<DateTimeValidationError | null>(null)

  const errorMsg = useMemo(() => {
    switch (error) {
      case 'invalidDate': {
        return ERROR_TEXT.dateFormat
      }
      default: {
        return ''
      }
    }
  }, [error])

  return (
    <MUIMobileDateTimePicker
      format="yyyy-MM-dd HH:mm"
      onError={(err) => setError(err)}
      slotProps={{
        textField: { fullWidth: true, variant: 'outlined', helperText: errorMsg },
      }}
      {...props}
    />
  )
}

export default MyDatePicker
